module.exports = __webpack_public_path__ + "img/transform_txt.8f2b2150.svg";